import { LynxWhiteboardLogo } from '@lynx/client-core/src/components'
import i18next from 'i18next'
import React from 'react'
import css from './Starting.module.scss'

export interface StartingProps {
	connected: boolean
	percent: number
	status: string
}

export const Starting = ({ connected, percent, status }: StartingProps): React.ReactElement | null => {
	if (connected) return null

	return (
		<div className={css['container']}>
			<div className={css['container__content']}>
				<LynxWhiteboardLogo />
				<p>{status}</p>
				<p className={css['container__preview']}>{i18next.t('pages.litb.featurePreview')}</p>
				<div className={css['progress-bar']}>
					<span className={css['progress-bar__inner']} style={{ width: `${percent}%` }} />
				</div>
			</div>
		</div>
	)
}
